import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import "../styles/NotificationBell.css";
import { apiUrl } from "../lib/api";

const NotificationBell = ({ userId: propUserId }) => {
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const userId = propUserId || localStorage.getItem("userId");

  const fetchNotifications = useCallback(async () => {
    if (!userId || userId === "undefined" || userId === "null") return;

    try {
      const res = await axios.get(apiUrl(`/api/notifications/${userId}`));
      setNotifications(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  }, [userId]);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 5000);
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  const handleBellClick = async () => {
    const willShow = !showDropdown;
    setShowDropdown(willShow);

    if (willShow && notifications.some((notification) => !notification.isRead)) {
      try {
      await axios.patch(apiUrl(`/api/notifications/mark-read/${userId}`));
        setNotifications((current) =>
          current.map((notification) => ({ ...notification, isRead: true })),
        );
      } catch (err) {
        console.error("Error marking notifications as read:", err);
      }
    }
  };

  const clearNotifications = async () => {
    try {
      await axios.delete(apiUrl(`/api/notifications/clear/${userId}`));
      setNotifications([]);
    } catch (err) {
      console.error("Failed to clear notifications:", err);
    }
  };

  const unreadCount = notifications.filter((notification) => !notification.isRead).length;

  return (
    <div className="notification-bell-container">
      <button className="bell-icon" onClick={handleBellClick} type="button" aria-label="Notifications">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 3a4 4 0 0 0-4 4v1.1c0 .7-.2 1.4-.6 2L6.3 12c-.6.9-1 1.9-1 3v1h13.4v-1c0-1.1-.3-2.1-1-3l-1.1-1.9c-.4-.6-.6-1.3-.6-2V7a4 4 0 0 0-4-4Zm0 18a2.7 2.7 0 0 1-2.6-2h5.2A2.7 2.7 0 0 1 12 21Z"
            fill="currentColor"
          />
        </svg>
        {unreadCount > 0 && <span className="notification-count">{unreadCount}</span>}
      </button>

      {showDropdown && (
        <div className="notification-dropdown">
          {notifications.length > 0 ? (
            <>
              <div className="notification-dropdown__header">
                <strong>Notifications</strong>
                <button className="clear-button" onClick={clearNotifications} type="button">
                  Clear
                </button>
              </div>
              <ul>
                {notifications.map((notification) => (
                  <li
                    key={notification._id}
                    className={notification.isRead ? "notification-item is-read" : "notification-item"}
                  >
                    {notification.message}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p className="empty-state">No notifications</p>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
